import { Button } from "./main-landing/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-24 md:py-32 bg-background border-t-2 border-border relative overflow-hidden">
      {/* Background mesh */}
      <div className="absolute inset-0 bg-gradient-mesh opacity-50"></div>

      <div className="relative z-10 container mx-auto px-4 md:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto text-center space-y-12">
          <div className="space-y-8">
            <span className="text-primary text-sm font-bold tracking-wider uppercase">
              READY TO BEGIN?
            </span>
            <h2 className="text-3xl md:text-5xl xl:text-7xl font-bold md:font-extrabold leading-[0.9] tracking-tighter text-foreground">
              Start with clarity on{" "}
              <span className="text-primary">what matters most.</span>
            </h2>

            <div className="w-24 h-1 bg-primary mx-auto"></div>

            <p className="text-lg md:text-2xl xl:text-3xl text-muted-foreground max-w-4xl mx-auto leading-relaxed font-medium">
              If you could see exactly where you're struggling—and how to fix
              it—wouldn't you want to?
            </p>
          </div>

          <div className="pt-12">
            <Button
              variant="glow"
              size="lg"
              className="group text-black hover:text-black"
              onClick={() => navigate("/life-score")}
            >
              Get your LIFE score
              <ArrowRight className="w-6 h-6 transition-transform group-hover:translate-x-1" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
